import PropTypes from 'prop-types';
import React from 'react';

const SessionsTabs = ({ onChange, children }) => {
  const handleClick = e => {
    const { value } = e.target;
    onChange({ value });
  };

  return (
    /* eslint-disable-next-line */
    <div className="flex" onClick={handleClick}>
      {children}
    </div>
  );
};

SessionsTabs.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
};

SessionsTabs.defaultProps = {
  onChange: () => {},
};

export default SessionsTabs;
